export const getLatestVideo = async () => {
  try {
    const response = await fetch(`https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCKswNyY6NqH0HATiHsQe3xw&maxResults=1&order=date&type=video&key=AIzaSyBEM9Q_3LByVFxCfQow1Ri6n66RbvwyrZ8`, {});
    const data = await response.json();
    return data.items[0].id.videoId;
  } catch (e) {
    return e;
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js